import { post } from 'communication/httpClient';
import { Dispatch } from 'react';
import { ACTIVITIES_LOADED, LOAD_ACTIVITIES, SYNC_FAILED } from './actionTypes';
import { IActivitiesAction } from './types';

export const getActions = (dispatch: Dispatch<IActivitiesAction>) => ({
  loadActivities: async (id: string) => {
    dispatch({
      type: LOAD_ACTIVITIES,
    });
    const sourcePromise = post('/api/account-profiles/picker/activity-type', {
      accountPurpose: 'Source',
      accountType: id,
    });
    const targetPromise = post('/api/account-profiles/picker/activity-type', {
      accountPurpose: 'Target',
      accountType: id,
    });

    const { data, error } = await Promise.all([sourcePromise, targetPromise]).then((responses) => {
      const failError = responses[0].error || responses[1].error;
      if (failError) {
        return { error: failError };
      }

      return {
        data: {
          sourceActivities: responses[0].data,
          targetActivities: responses[1].data,
        },
      };
    });

    if (data) {
      dispatch({
        type: ACTIVITIES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
});
